import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchEquipments = () => api.get('/equipment/search').then((res) => res.data);

export default function useCompanies() {
  return useQuery('equipments', fetchEquipments);
}